var exports = {
  "n": "xdbfd91f1--1c7d44--link",
  "b": "xdbfd91f1--1c7d44--link--active",
};

module.exports = exports;
